import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { UserOutlined, TeamOutlined, SafetyCertificateOutlined, AuditOutlined } from '@ant-design/icons';
import { useContext } from 'react';
import { AppContext } from '../../../context/AppContext';
import * as AppPermissions from '../../../Util/permissions';
import CardsContainer from '../../components/CardsContainer';
import StyledCard from '../../components/StyledCard';
import './SettingsLayout.css';
import ActionBar from '../../components/ActionBar';

const SettingsLayout = ({ children }) => {
    const history = useHistory();
    const location = useLocation();
    const { permissions } = useContext(AppContext);
    
    const navigationItems = [
        {
            key: 'account',
            label: 'Account',
            icon: <UserOutlined />,
            description: 'Manage your personal account settings and change password',
            route: 'account'
        },
        {
            key: 'users',
            label: 'Users',
            icon: <TeamOutlined />,
            description: 'Manage user accounts and access',
            route: 'users',
            requiredPermissions: [AppPermissions.CAN_READ_USER, AppPermissions.CAN_CREATE_PIT_USER, AppPermissions.CAN_CREATE_PCT_USER],
        },
        {
            key: 'roles',
            label: 'Roles & Permissions',
            icon: <SafetyCertificateOutlined />,
            description: 'Define roles and assign permissions',
            route: 'roles',
            requiredPermissions: [AppPermissions.CAN_READ_ROLE],
        },
        {
            key: 'audit-logs',
            label: 'Audit Logs',
            icon: <AuditOutlined />,
            description: 'View system activities and user actions',
            route: 'audit-logs',
            requiredPermissions: [AppPermissions.CAN_READ_AUDIT_LOG],
        }
    ];

    const handleCardClick = (item) => {
        const currentPath = location.pathname;
        const basePath = currentPath.split('/settings')[0];
        const targetPath = `${basePath}/settings/${item.route}`;
        
        history.push(targetPath);
    };

    return (
        <div className="settings-container">
            <div className="settings-header-content">
                <ActionBar actionButtonProp={{ title: 'System Settings' }} />
            </div>

            <div className="settings-content">
                <CardsContainer
                    title=""
                    overflowX="none"
                    flexWrap="wrap"
                >
                    {navigationItems
                        .filter(item => {
                            if (!item.requiredPermissions && !item.requiredPermission) return true;
                            
                            const permissionsToCheck = item.requiredPermissions || (item.requiredPermission ? [item.requiredPermission] : []);
                            
                            if (item.key === 'users') {
                                return permissionsToCheck.some(permission => permissions.includes(permission));
                            }
                            
                            return permissionsToCheck.every(permission => permissions.includes(permission));
                        })
                        .map((item) => (
                            <StyledCard
                                key={item.key}
                                title={item.label}
                                icon={item.icon}
                                onClick={() => handleCardClick(item)}
                            />
                        ))}
                </CardsContainer>

                <div className="settings-main-content">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default SettingsLayout; 